// Only valid for the SGP layout: widths track PSPHero.scss's `.sgp-hero`
// max-widths (319/400/480px), breakpoints track $breakpoints.medium/large
// (app/styles/_variables.scss). PSP hero images render through FramedImage
// at a fixed ~480px box instead, so this constant must not be applied there.
export const SGP_HERO_IMAGE_SIZES =
	'(min-width: 767px) 480px, (min-width: 576px) 400px, 319px';
